import { Controller } from "stimulus";
import copy from 'copy-to-clipboard';
import toastr from 'toastr';

export default class ShareTextController extends Controller {
  static targets = [
    "text"
  ]

  copy() {
    const targetText = this.textTarget.value
    copy(targetText)
    toastr.options.positionClass = 'toast-bottom-center'
    toastr.options.timeOut = 2000
    toastr.success('コピーしました')
    console.log(`copied ${targetText}`)
  }
}
